import { FC } from 'react';
import { Stack, Typography } from '@mui/material';
import { Link } from '@vs-online-only-app/ui';
import styled from 'styled-components';

const StyledLink = styled(Link)`
  text-decoration: none;
`;

interface AppLogoProps {
  retailerName?: string;
}

const AppLogo: FC<AppLogoProps> = ({ retailerName }) => (
  <Stack direction="row" alignItems="center" spacing={1}>
    <Typography variant="h6">
      <StyledLink to="/" replace>
        Bambuser Chat
      </StyledLink>
    </Typography>
    {retailerName && (
      <Typography variant="subtitle1">
        <StyledLink to="/" replace>
          &mdash; {retailerName}
        </StyledLink>
      </Typography>
    )}
  </Stack>
);

export default AppLogo;
